import { Button } from "./ui/button";
import { Maximize2 } from "lucide-react";

export let globalFullscreenState = {
  isOpen: false,
  listeners: new Set<() => void>(),
  setOpen: (open: boolean) => {
    globalFullscreenState.isOpen = open;
    globalFullscreenState.listeners.forEach((listener) => listener());
  },
  subscribe: (listener: () => void) => {
    globalFullscreenState.listeners.add(listener);
    return () => {
      globalFullscreenState.listeners.delete(listener);
    };
  },
};

export function GlobalFullscreenDialog() {
  return null;
}

interface FullscreenSidebarProps {
  children: React.ReactNode;
  trigger?: React.ReactNode;
}

export function FullscreenSidebar({ children, trigger }: FullscreenSidebarProps) {
  const handleTriggerClick = () => {
    globalFullscreenState.setOpen(true);
  };

  const defaultTrigger = (
    <Button variant="outline" size="icon" title="Open in fullscreen" onClick={handleTriggerClick}>
      <Maximize2 />
    </Button>
  );

  const customTrigger = trigger ? <div onClick={handleTriggerClick}>{trigger}</div> : defaultTrigger;

  return customTrigger;
}

export function closeFullscreenDialog() {
  if (!globalFullscreenState.isOpen) return;
  globalFullscreenState.setOpen(false);
}
